import type {Contact, Route} from '@yandex-delivery/order-form/src/types'
import {useController, useFormContext} from 'react-hook-form'

import {
  defaultCoordinates,
  useAddDestinationAction,
} from '../../../../../actions/AddDestination/useAddDestinationAction'
import {FieldName} from '../../../../../lib/fieldNames'
import {useRouteOptimizationButton} from './use-route-optimization-button'

export type Props = {
  routePointIndex: number
  addressName: string
  pointId: string
}

export function useAddressWidget(props: Props) {
  const {routePointIndex, addressName, pointId} = props
  const triggerAddDestinationAction = useAddDestinationAction()
  const {watch} = useFormContext()
  const {setRouteUnoptimized} = useRouteOptimizationButton()
  /** контроллер не отслеживает изменения, произошедшие вне его onChange,
   * поэтому значения полей приходится брать из watch */
  const route = watch('route')
  const contacts = watch('contacts')

  const {
    field: {onChange: updateContacts},
  } = useController({name: FieldName.Contacts})
  const {
    field: {value: defaultRouteFieldValue, onChange: updateRoute},
  } = useController({name: FieldName.Route})
  const {
    field: {value: address, onChange: updateAddress},
  } = useController({name: addressName})

  const handleRemoveAddress = () => {
    const newRoute: Route = {}
    const newContacts: Contact[] = []

    let indexOffset = 0

    if (route) {
      const {return: returnPoint, ...routeWithoutReturn} = route
      Object.keys(routeWithoutReturn).forEach((key, index) => {
        const newKey = ['source', 'return'].includes(key) ? key : `destination_${index - indexOffset}`
        if (key === pointId) {
          indexOffset += 1
        } else {
          newRoute[newKey] = route[key]
          const contact = contacts.find((c: Contact) => c.pointId === key)
          newContacts.push({...contact, pointId: newKey})
        }
      })

      if (returnPoint) {
        newRoute['return'] = returnPoint
      }
    }

    updateRoute(newRoute)
    updateContacts(newContacts)

    setRouteUnoptimized()
  }

  const destinationCount = defaultRouteFieldValue
    ? Object.keys(defaultRouteFieldValue).filter(key => key.startsWith('destination_')).length
    : 1

  const addDestination = () => {
    /** чтобы из ручки формы возвращалось правильное количество виджетов точки назначения, адрес,
     * на котором вызывается добавление,должен быть либо определен, либо застабан дефолтными координатами.
     * Добавляю в событии, которое триггерится юзером, чтобы не задеть начальные асинхронные стейты формы */
    if (!address) {
      updateAddress({coordinates: defaultCoordinates})
    }
    triggerAddDestinationAction()
    setRouteUnoptimized()
  }

  return {
    addDestination,
    handleRemoveAddress,
    destinationCount,
    isFinalRoutePoint: destinationCount === routePointIndex,
  }
}
